<template>
   <div>
    
    <vx-card class="p-5" v-if="TraineeAttendance.length>0">
     <vs-table ref="table"   class="mr-5 ml-5" pagination :max-items="10"  :data="TraineeAttendance">
        <template slot="thead">
           <vs-th sort-key="Trainee">{{$t('CourseClass')}}</vs-th>
          <vs-th sort-key="Trainee">{{$t('Session')}}</vs-th>
           <vs-th sort-key="Trainee">{{$t('From')}}</vs-th>
             <vs-th sort-key="Trainee">{{$t('To')}}</vs-th>
          <vs-th sort-key="Attended">{{$t('IsAttended')}}</vs-th>
        </template>
        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
               <vs-td>
                <p class="product-name font-medium truncate">{{ tr.CourseClassSession.CourseClass.ClassNo }}</p>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.CourseClassSession.Subject }}</p>
              </vs-td>
               <vs-td>
                <p class="product-name font-medium truncate">{{ tr.CourseClassSession.Start }}</p>
              </vs-td>
               <vs-td>
                <p class="product-name font-medium truncate">{{ tr.CourseClassSession.End }}</p>
              </vs-td>
               <vs-td>
                   <vs-checkbox color="success" :disabled="true" v-model="tr.IsAttended">{{$t('IsAttended')}}</vs-checkbox>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
    </vs-table>
    <div class="flex flex-wrap items-end p-6" slot="footer">
    
      
      <vs-button type="border" color="danger" @click="cancel">{{$t('Cancel')}}</vs-button>
    </div>
    </vx-card>
   </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker';
import moduleTraineeAttendance from "@/store/traineeAttendance/moduleTraineeAttendance.js";
export default {
    components:{
        Datepicker
    },
    data(){
        return{
              format:"dd-MM-yyyy",
            search:{}
        }
    },
    computed:{
     
        sessions()
        {
          return this.$store.state.courseClassList.courseClassSessions;
        },
        TraineeAttendance(){
            return this.$store.state.traineeAttendanceList.traineeAttendance;
        }
    },
    methods:{
        cancel()
        {
            this.$router.push('/TraineeOfCustomer'); 
        },
       
        formatJsDate(dateToFormat)
        {
            return dateToFormat.getFullYear()+"-"+ (dateToFormat.getMonth()+1)+"-"+dateToFormat.getDate();
        },
    },
    created()
    {
      // this.$store.dispatch("courseClassList/GetCourseClassByInstructorID");
          if (!moduleTraineeAttendance.isRegistered) {
          this.$store.registerModule("traineeAttendanceList", moduleTraineeAttendance);
         moduleTraineeAttendance.isRegistered = true;
         debugger;
         this.$store.dispatch("traineeAttendanceList/GetTraineeAttendanceByTraineeID",this.$route.params.TraineeID);

       }

       
    }
}
</script>



<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>

<style>
  .vdp-datepicker__calendar
  {
    z-index: 429!important;
  }
</style>